module.exports = __webpack_public_path__ + "img/robo.cfbdd131.jpg";